import { useEffect, useState } from "react";
import { useOffline } from "../../offline/OfflineContext";
import { countUnsentEntriesOnDevice } from "../../offline/unsentEntries";

/**
 * Counts once the entries on this device that the server has not received yet, of every person and
 * tenant (F-84). Operator staff record nothing and nothing is synchronized for them (F-69), so the
 * outbox does not change while the operator area is shown; entries recorded earlier in the
 * application of the tenants, by an account that has a tenant role as well, stay until the sign-out
 * deletes them. The store counts through its index and reads no entry. A store that cannot be read
 * (closed while signing out) leaves the result open.
 *
 * @returns The number of unsent entries, or `null` until it is read.
 */
export function useUnsentCountOnDevice(): number | null {
  const { store } = useOffline();
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let active = true;
    const read = async (): Promise<void> => {
      const counted = await countUnsentEntriesOnDevice(store);

      if (active) {
        setCount(counted);
      }
    };

    read().catch(() => undefined);

    const stop = (): void => {
      active = false;
    };

    return stop;
  }, [store]);

  return count;
}
